module.exports = __webpack_public_path__ + "static/media/icon-briefcase-outline.20132b90.svg";